<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->

      <v-toolbar color="#7e5ec2">
        <span class="material-symbols-outlined"> </span>
        <p class="tituloCard">Aprobar uso de vacación</p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong> {{ this.form.numero }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.form.nombres }}
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <h4>
                  <strong>{{ subtitulo_detalle }} </strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.dias }}</td>
                    <!-- <td class="text-xs-center">{{ props.item.estado }}</td> -->
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              v-if="
                lista_reprogramaciones.length > 0 &&
                (form.tipo == 'FR' || form.tipo == 'R')
              "
            >
              <h4><strong>Detalle de reprogramación de vacación</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  v-if="
                    lista_reprogramaciones.length > 0 &&
                    (form.tipo == 'FR' || form.tipo == 'R')
                  "
                  :items="lista_reprogramaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers_reprogramaciones"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4>
                <strong>{{ subtitulo_seguimiento }}</strong>
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                    <td class="text-xs-center">{{ props.item.jefe }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="rgba(14, 187, 178, 0.6)" @click.prevent="aprobarUso()"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {
        funcionario: {
          nombre: "",
        },
      },
      //url: 'vCronoVacass',
      subtitulo_detalle: "Detalle de vacación programada",
      subtitulo_seguimiento: "Seguimiento de vacación programada",
      valid: false,
      loading: false,
      estado_vacacion: [],
      lista_reprogramaciones: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      lista_papeleta: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
      ],
    };
  },
  async mounted() {
    this.$bus.$on(
      "openDialogAprobarUsoJefeSuperiorJerarquico",
      async (item) => {
        this.form = item;
        if (this.form.tipo == "FR") {
          await this.cargarReprogramaciones();
          this.titulo = "Ver reprogramación de vacaciones";
          this.subtitulo_detalle =
            "Detalle de vacación programada a ser reprogramada";
          this.subtitulo_seguimiento =
            "Seguimiento de reprogramación de vacación";
        }
        if (this.form.tipo == "R") {
          this.titulo = "Ver reprogramación de vacación";
          this.subtitulo_detalle = "Detalle de vacación reprogramada";
          this.subtitulo_seguimiento = "Seguimiento de vacación reprogramada";
        }
        this.cargarTablaPapeleta();
        this.dialog = true;
        await this.cargarSeguimiento();
      }
    );
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: "",
        },
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogAprobarUsoJefeSuperiorJerarquico");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      const elemento = {
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta,
        dias: this.form.dias,
      };
      this.lista_papeleta.push(elemento);
    },
    async cargarReprogramaciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion}"){
                      respuesta
                  }
                  }
              `,
        });
        if (respuesta.runQuery.resps.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
          this.lista_reprogramaciones = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarSeguimiento() {
      try {
        let respuesta;
        let id_vaca_programada = parseInt(this.form.id_vacacion);
        if (this.form.tipo == "FR") {
          //SEGUIMIENTO DE LOS HIJOS
          id_vaca_programada = parseInt(
            this.lista_reprogramaciones[0].id_vacacion_programada
          );
        }
        respuesta = await this.$service.graphql({
          query: `
			  query{
				  runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${id_vaca_programada}"){
					  respuesta
				  }
				  }
			  `,
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_detalle = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async aprobarUso() {
      let respuesta;
      let resps = [];
      let correcto;
      let user = this.$storage.get("user");
      let id_funcionario = user.id;
      this.form.motivo = "0 motivo";
      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
									 query{
                                      runQuery(consulta:"select vacaciones.fn_aprueba_uso_vacacion_programada(${parseInt(
                                        this.form.id_vacacion
                                      )},65,${parseInt(user.id)})"){
                                        respuesta
                                      }
                                    }
								`,
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_aprueba_uso_vacacion_programada;
        resps = respuesta.split("|");
        correcto = resps[0];

        if (correcto === "1") {
          this.$confirm("La solicitud de uso fué aprobada exitosamente", () => {
            this.loading = false;
            this.close();
          });
        } else {
          this.$confirm(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 84);
  font-weight: bolder;
}
</style>





// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/AprobarUsoJefeSuperiorJerarquico.vue